import React from 'react'
import './NavBar.css';

const NavBar = ({useFahrenheit, setUseFahrenheit}) => {
  
  function login(){
    
  }

  return (
    <div className='NavBar'>
      <div className='leftContent'>
        <div className='webTitle'>
            <a href='/' className=''>
              {/* 📈 */}
              <img src={require("../assets/logo.png")} alt="logo" title="Stockit" className='webIcon'/>
              
            <i>Stockit</i>
            </a>
        </div>
        <div className='navLinks'>
          <span className='divider'>|</span>
          <a className='navLink' href="/pricing">Pricing</a>
          <a className='navLink' style={{opacity:'.3', cursor: 'default'}}>API Docs</a>
          <a className='navLink' style={{opacity:'.3', cursor: 'default'}}>FAQs</a>
        </div>
        <div className='mobileNav'>
          <a className='navLink' href="/pricing">Pricing</a>
          </div>
      </div>
      {/* <button className="customButton" onClick={login}>Log in&ensp;→</button> */}
    </div>
  )
}

export default NavBar